/*global Modernizr, tec_get_percentageSeen */
/*jslint browser:true */

(function() {
  'use strict';

  var animation_bars = document.querySelectorAll('.tec-dv-contributions-bar');
  if(animation_bars) {
    const animation_bars_handler = function() {
      animation_bars.forEach((animation_bar) => {
        if(animation_bar.checkVisibility() && tec_get_percentageSeen(animation_bar) > 30) {
          animation_bar.style.width = ((animation_bar.getAttribute('data-value') / animation_bar.getAttribute('data-max-value')) * 100) + '%';
        }
      });
    };

    addEventListener('DOMContentLoaded', animation_bars_handler, false);
    addEventListener('load', animation_bars_handler, false);
    addEventListener('scroll', animation_bars_handler, false);
    addEventListener('resize', animation_bars_handler, false);
    addEventListener('tab-opened', animation_bars_handler, false);
  }
}());